import { ApiHelper, axiosInstance } from "../../utils/ApiHelper"
import { routerMiddleware, push, replace } from "react-router-redux"

// export function showIntegration(new_account_token) {
//   return dispatch => {
//     dispatch({
//       type: "SHOW_INTEGRATION_REQUEST",
//       new_account_token
//     })
//     ApiHelper.showFreshbooksAccount(new_account_token).then(({ data }) => {
//       dispatch({
//         type: "SHOW_INTEGRATION_SUCCESS",
//         payload: data
//       })
//     })
//   }
// }

export function enableFreshbooks() {
  return (dispatch, getState) => {
    const { token_id } = getState().models.user
    if (!token_id) {
      // wait for getUser() if needed
      setTimeout(() => dispatch(enableFreshbooks()), 500)
      return
    }

    window.location.replace(
      `${
        process.env.REACT_APP_API_BASE_URL
      }freshbooks/connect?token_id=${token_id}&redirect_uri=${
        window.location.href
      }`
    )
    // window.open(
    //   `https://my.freshbooks.com/service/auth/oauth/authorize?client_id=${
    //     process.env.REACT_APP_FRESHBOOKS_CLIENT_ID
    //   }&response_type=code&redirect_uri=${
    //     // TODO use env:
    //     process.env.REACT_APP_FRESHBOOKS_REDIRECT
    //     // "https://api.lvh.me:3000/v6/freshbooks/callback"
    //
    //     // TODO try using env after robs fix: REACT_APP_API_BASE_URL=http://api.lvh.me:3000/v6/
    //   }&state={"redirect_to":"${
    //     window.location.href
    //   }","user_token":"${token_id}"}`,
    //   // }&state={"redirect_to":"http://localhost:8080/account/integrations","user_token":"${token_id}"}`,
    //   "targetWindow"
    //   // "menubar=1,resizable=1,width=350,height=250"
    //   // 'toolbar=no,
    //   //  location=no,
    //   //  status=no,
    //   //  menubar=no,
    //   //  scrollbars=yes,
    //   //  resizable=yes,'
    //   // width=SomeSize,
    //   // height=SomeSize'
    // )

    dispatch({
      type: "ENABLE_FRESHBOOKS"
    })
  }
}

export function disableFreshbooks() {
  return (dispatch, getState) => {
    const { integration_accounts } = getState().models.user
    const { token_id } = integration_accounts.find(
      ia => ia.oauth_token.provider == "freshbooks"
    )
    dispatch({
      type: "DISABLE_INTEGRATION_REQUEST",
      token_id
    })
    ApiHelper.deleteFreshbooksAccount(token_id).then(({ data }) => {
      dispatch({
        type: "DISABLE_INTEGRATION_SUCCESS",
        token_id,
        payload: data,
        integration: "freshbooks"
      })
    })
  }
}

export function enableXero() {
  return (dispatch, getState) => {
    const { token_id } = getState().models.user
    if (!token_id) {
      // wait for getUser() if needed
      setTimeout(() => dispatch(enableXero()), 500)
      return
    }

    dispatch({
      type: "ENABLE_XERO"
    })
    window.location.replace(
      `${
        process.env.REACT_APP_API_BASE_URL
      }xero/connect?token_id=${token_id}&redirect_uri=${window.location.href}`
    )

    // ApiHelper.connectXero(token_id).then(({ data }) => {
    //   alert("redirecting...")
    //   dispatch({
    //     type: "ENABLE_XERO_SUCCESS",
    //     token_id,
    //     payload: data,
    //     integration: "xero"
    //   })
    // })
  }
}

export function disableXero() {
  return (dispatch, getState) => {
    const { integration_accounts } = getState().models.user
    const { token_id } = integration_accounts.find(
      ia => ia.oauth_token.provider == "xero"
    )
    dispatch({
      type: "DISABLE_INTEGRATION_REQUEST",
      token_id
    })
    ApiHelper.deleteXeroAccount(token_id).then(({ data }) => {
      dispatch({
        type: "DISABLE_INTEGRATION_SUCCESS",
        token_id,
        payload: data,
        integration: "xero"
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/account/integrations/actions.js